import classnames from 'classnames'
import React from 'react'
import { FieldError, UseFormRegister } from 'react-hook-form'

import { isEmailInput, normalizeEmailInputValue } from './emailInput'

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  registration: Partial<UseFormRegister<any>>
  containerClassName?: string
  label: string
  showLabel?: boolean
  errors?: FieldError
  size?: 'sm' | 'lg'
}

export const Input = React.forwardRef<HTMLInputElement, React.PropsWithChildren<InputProps>>((props: InputProps, ref) => {
  const {
    className,
    containerClassName,
    registration,
    type = 'text',
    placeholder,
    autoComplete = 'off',
    id,
    showLabel = false,
    label,
    errors,
    children
  } = props
  const registrationProps = registration as React.InputHTMLAttributes<HTMLInputElement>
  const shouldNormalizeEmail = isEmailInput({ type, id, name: registrationProps.name, label })
  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    e.target.value = normalizeEmailInputValue(e.target.value, shouldNormalizeEmail) as string
    registrationProps.onChange?.(e)
  }

  return (
    <div className={classnames('mb-4', containerClassName)}>
      <label className={classnames('block pl-2 pb-2 text-md text-primary-content font-bold', { 'sr-only': !showLabel })} htmlFor={id}>
        {label}
      </label>
      <div className='relative'>
        <input
          id={id}
          ref={ref}
          type={type}
          placeholder={placeholder}
          className={classnames(
            'input-bordered bg-secondary text-secondary-content input w-full h-[55px] rounded-[27px]',
            { 'input-error': errors },
            className
          )}
          autoComplete={autoComplete}
          {...registration}
          autoCapitalize={shouldNormalizeEmail ? 'none' : props.autoCapitalize}
          spellCheck={shouldNormalizeEmail ? false : props.spellCheck}
          onChange={handleChange}
        />
        {children}
      </div>
      <p className='pl-2 pt-2 text-rose-600 text-sm'>{errors?.message}</p>
    </div>
  )
})

Input.displayName = 'Input'
